import {HTMLAttributes} from 'react';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP} from '../../../domain/content/[seriesId]/constant';
import {getContentHomeWaitfreeBadgeType} from '../../../domain/content/[seriesId]/util/getContentHomeWaitfreeBadgeType';
import {isMixedBm} from '../../../domain/content/[seriesId]/util/isMixedBm';
import {
  Bm,
  ContentHomeBadgeType,
  Maybe,
  SaleMethod,
  SaleState,
} from '../../../graphql/generated/types';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {LabelBadge} from '../../molecules/LabelBadge/LabelBadge';
import {LabelBadge18Type} from '../../molecules/LabelBadge/LabelBadge18Type.enum';
import {LabelBadgeSizeType} from '../../molecules/LabelBadge/LabelBadgeSizeType.enum';
export interface ContentOverviewThumbnailBadgeProps
  extends HTMLAttributes<HTMLDivElement> {
  chargedAt?: Date;
  chargedPeriodByMinute?: Maybe<number>;
  displayPeriodByMinute?: Maybe<number>;
  waitfreePeriodByMinute?: Maybe<number>;
  isChargedComplete?: Maybe<boolean>;
  bm?: Maybe<Bm>;
  baseDate?: Date;
  saleState: SaleState;
  saleMethod: SaleMethod;
  discountRateText?: Maybe<string>;
}

export function ContentOverviewThumbnailBadge({
  saleState,
  displayPeriodByMinute,
  chargedAt,
  chargedPeriodByMinute,
  waitfreePeriodByMinute,
  isChargedComplete,
  bm,
  className,
  baseDate = new Date(),
  onClick,
  saleMethod,
  discountRateText,
  ...props
}: ContentOverviewThumbnailBadgeProps) {
  if (saleState === SaleState.Stop) {
    return (
      <LabelBadge
        sizeType={LabelBadgeSizeType.Size18}
        type={LabelBadge18Type.red}
        label={t('contenthome_badge_nosale')}
        className={className}
        {...props}
      />
    );
  }

  if (saleMethod === SaleMethod.Cash && discountRateText) {
    return (
      <LabelBadge
        sizeType={LabelBadgeSizeType.Size18}
        type={LabelBadge18Type.red}
        label={discountRateText}
        className={className}
      />
    );
  }

  const BmBadge = () => {
    if (bm === Bm.PayWaitfree) {
      if (!isChargedComplete && chargedPeriodByMinute) {
        return (
          <Icon
            type={
              CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP[
                getContentHomeWaitfreeBadgeType(chargedPeriodByMinute) ||
                  ContentHomeBadgeType.BadgeWaitfree
              ] || IconType.ContentHomeTimeStatic
            }
            className="h-18pxr"
            disableActiveEffect
          />
        );
      }

      return (
        <Icon
          type={
            CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP[
              getContentHomeWaitfreeBadgeType(waitfreePeriodByMinute) ||
                ContentHomeBadgeType.BadgeWaitfree
            ] || IconType.ContentHomeTimeStatic
          }
          className="h-18pxr"
          disableActiveEffect
        />
      );
    }

    if (bm && (bm === Bm.FreePreview || isMixedBm(bm))) {
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={LabelBadge18Type.yellow}
          label={t('common_badge_ongoing_free')}
        />
      );
    }

    return null;
  };

  if (bm === Bm.Pay || bm === Bm.Free) {
    return null;
  }

  return (
    <>
      <div
        className={twMerge('flex flex-col items-start space-y-2pxr', className)}
        {...props}
      >
        <BmBadge />
      </div>
    </>
  );
}
